import React from "react";
import PropTypes from "prop-types";
import "./GeneralButton.css";

// 通常のボタン
function GeneralButton(props) {
  const {
    buttonLabel,
    type = "primary-blue",
    onClick,
    size = "normal",
  } = props;

  // クラス名を動的に設定
  const className = `general-button ${type}`;

  // 幅とフォントサイズのスタイルを動的に設定
  const style = {
    width: size === "minFit" ? "fit-content" : "initial",
    minWidth: size === "minFit" ? "1px" : "60px",
    fontSize: size === "normal" ? "16px" : "14px",
    fontWeight: "bold",
  };

  return (
    <div
      className={className}
      onClick={
        type !== "disabled" ? onClick || GeneralButton.defaultOnClick : null
      }
      style={style}
    >
      {buttonLabel}
    </div>
  );
}

// デフォルトの onClick ハンドラ
GeneralButton.defaultOnClick = () => {};

// PropTypesを使ってプロパティの型を定義
GeneralButton.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  type: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string, // サイズのプロパティを追加
};

export default GeneralButton;
